import script from "./DocumentTotal.vue?vue&type=script&setup=true&lang=ts"
export * from "./DocumentTotal.vue?vue&type=script&setup=true&lang=ts"

import "./DocumentTotal.vue?vue&type=style&index=0&id=5773dd1b&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5773dd1b"]])

export default __exports__